import { render, staticRenderFns } from "./ClientTab.vue?vue&type=template&id=25f35971"
import script from "./ClientTab.vue?vue&type=script&lang=js"
export * from "./ClientTab.vue?vue&type=script&lang=js"
import style0 from "./ClientTab.vue?vue&type=style&index=0&id=25f35971&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports